var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistantLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2H14M14 2V5.33333M14 2L9.33333 6.66667M12.6667 9.33333V12.6667C12.6667 13.4033 12.07 14 11.3333 14H3.33333C2.59667 14 2 13.4033 2 12.6667V4.66667C2 3.93 2.59667 3.33333 3.33333 3.33333H6.66667",
    stroke: "#122D52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantLink);
export default __webpack_public_path__ + "static/media/assistant_link.5a190029fddb97afd890b376d5904930.svg";
export { ForwardRef as ReactComponent };